import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./modalForEditTable.css"
import "./modalForEditTableDark.css"
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { Input ,InputGroup,InputLeftAddon} from '@chakra-ui/react'
import { useToast } from '@chakra-ui/react'
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../../../../redux/reducer/postFetcReducer/action/action";



export default function ModalFromEdit({ shows, currentDate, setShows }) {
  const getDarkModoe = useSelector(darkModes => darkModes )
  const [show, setShow] = useState(false);
  const [currentRol, setcurrentRol] = useState("");
  const [loading, setloading] = useState(false);
  const toast = useToast()
  const dipatch = useDispatch()


  const handleClose = () => {
     
    setShow(false);
    setShows(false);
  }



//обновить информацию о сотруднике
const handleUpdate=()=>{
    if (currentRol) {
      setloading(true)
  axios.patch('/alldeploy/api', {
    currentDate,
    currentRol
  })
  .then(function (response) {
    console.log(response);
    setShow(false);
    setShows(false);
    dipatch(fetchUsers())
  })
  .catch(function (error) {
    console.log(error);
    setShow(true);
    setShows(true);
    toast({
      title: 'Ошибка',
      description:error.response.data.message,
      status: "error",
      duration: 3000,
      isClosable: true,
      position:"top"
    })
  }).finally(fin=>{
    setloading(false)
  })
    }else{
      toast({
        title: 'Выберите другую роль для изменения.',
        description: "Выберите другую роль для изменения.",
        status: "error",
        duration: 2000,
        isClosable: true,
        position:"top"
      })
    }
  
};


//для показа modal
  useEffect(() => {

    setShow(shows);
   
  }, [shows]);

  return (
    <div className="editemploysCont">
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}
{/* здесь мы видим информацию о сотруднике (modal) */}
      <Modal show={show} onHide={handleClose} className={getDarkModoe.ToggleDarkModeReducer.chekced?"modalContEditEmployDark":"modalContEditEmploy"}>
      
        {/* {getDarkModoe.ToggleDarkModeReducer.chekced?"addNewUserDark":"addNewUserContLgit"} */}
        <div className={getDarkModoe.ToggleDarkModeReducer.chekced?"EditemploysDark":"EditemploysLight"}>

          <div className="left">
               <h1 className="editTextifno">Редактировать профиль</h1>
       
                <img  src={currentDate.img?currentDate.img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTe0qkX7CGP28JHWYVUlbUOAe27r9YPPx0SqgiYJV9rWMlFvMPXuhswH4xaWyIrYF9xWY&usqp=CAU"} width="100" />
                <p className="name">{currentDate.name}</p>
                <p className="email">{currentDate.email}</p>
                <p className="tel" style={{textAlign:"center"}}>{currentDate.tel}</p>
             
      
          </div>
          <div className="rigth">
                               <label htmlFor="" className="editemploLabel">
                                <p>Почта</p>
                                <input type="text" className="editemploLabel"  placeholder="Электронная почта" defaultValue={currentDate.email} disabled/>
                                </label>
                                <label htmlFor="" className="editemploLabel">
                                  <p>Роль</p>
                                  <select  onChange={(e)=> setcurrentRol(e.target.value)} style={{backgroundColor:getDarkModoe.ToggleDarkModeReducer.chekced?"#21262E":"#F5F5F5"}}>
                        
                            
                        {["Менеджер маркетплейсов","Контент менеджер","SEO-специалист","Дизайнер"].map((item,index)=>{
                                if (item === currentDate.rols) {
                                  
                                  return(
                                    <option value={item} key={index} selected >{item}</option>
                                  )
                                }else{
                                  return(
                                
                                    <option value={item} key={index}>{item}</option>
                                  )
                                }
                        
                      })}
                              </select>
                                  </label>
                                  <label htmlFor="" className="editemploLabel">
                                    <p>Имя</p>
                                  <input type="text" defaultValue={currentDate.tel} disabled placeholder="Номер телефона"/>
                                </label>
                                <label htmlFor="" className="editemploLabel">
                                <p>Телефон</p>
                                <input type="text"  placeholder="Имя" defaultValue={currentDate.name} disabled/>
                                </label>
            </div>
        </div>
        <div className={getDarkModoe.ToggleDarkModeReducer.chekced?"btnEditEnploysDark":"btnEditEnploys"}>
        {loading?
           <Button style={{background:"#5E7DE8",outline:"none",border:"none"}} disabled>
           <Spinner
             as="span"
             animation="grow"
             size="sm"
             role="status"
             aria-hidden="true"
           />
           Загрузка...
         </Button>
          :
          <button  onClick={handleUpdate} className="saveEmployBTN">
          Сохранять
          </button>
          }                 

          <button className="closeEmployBTN" onClick={handleClose}>
          Закрывать
          </button>
        </div>
        
      </Modal>
    </div>
  );
}
